import { useTranslation } from 'react-i18next'
import { User } from 'lucide-react'

interface TypingIndicatorProps {
    userNames: string[]
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userNames }) => {
    const { t } = useTranslation()

    if (userNames.length === 0) return null

    const displayText =
        userNames.length === 1
            ? userNames[0]
            : userNames.length === 2
              ? `${userNames[0]} & ${userNames[1]}`
              : `${userNames.length} ${t('people')}`

    return (
        <div className="flex justify-start gap-2.5 mb-3 w-full">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-gray-400 to-gray-500 flex items-center justify-center flex-shrink-0 shadow-sm">
                <User size={18} className="text-white" />
            </div>
            <div className="max-w-[70%]">
                <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-semibold text-gray-600">
                        {displayText}
                    </span>
                    <span className="text-[10px] text-gray-400 italic">
                        {t('typing')}...
                    </span>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-md px-4 py-3 shadow-sm">
                    <div className="flex gap-1.5 items-center">
                        <span
                            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                            style={{
                                animationDelay: '0ms',
                                animationDuration: '0.8s',
                            }}
                        />
                        <span
                            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                            style={{
                                animationDelay: '150ms',
                                animationDuration: '0.8s',
                            }}
                        />
                        <span
                            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                            style={{
                                animationDelay: '300ms',
                                animationDuration: '0.8s',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TypingIndicator
